export default __webpack_public_path__ + "static/media/two_green.96758884.svg";